/* istanbul ignore file */

import { useState } from 'react';

import * as tracking from './tracking';
import { dispatchCustomEvent, useCustomEvent } from 'client-site-chrome-ui/hooks/useCustomEvent';

const OPEN_NAVIGATION_EVENT = 'OPEN_NAVIGATION_EVENT';

export const useNavigationModal = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const setOpen = (state: boolean) => {
    tracking.setNavOpen(state);
    setIsOpen(state);
  };

  /*
    handle updates using custom events to enable components rendered in different contexts to communicate.
    This is only need for the mononoth integration.
    This is similar with what we are doing in useLocaleModal.ts
  */
  useCustomEvent(OPEN_NAVIGATION_EVENT, (evt: Event) => {
    const data = (evt as CustomEvent).detail as { isOpen: boolean };
    setIsOpen(data.isOpen);
  });

  return {
    isOpen,
    open: () => {
      setOpen(true);
      dispatchCustomEvent(OPEN_NAVIGATION_EVENT, { isOpen: true });
    },
    close: () => {
      setOpen(false);
      dispatchCustomEvent(OPEN_NAVIGATION_EVENT, { isOpen: false });
    },
    closeWithoutTracking: () => {
      setIsOpen(false);
      dispatchCustomEvent(OPEN_NAVIGATION_EVENT, { isOpen: false });
    },
  };
};
